module.exports = __webpack_public_path__ + "img/KHO.9eb1b112.png";